export default __webpack_public_path__ + "static/media/ss3.cc21b829.png";